import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Moment from 'moment';
import User from '_class/User';
import { PRESCHOOL } from 'constants/schoolTypes';
import { isUserTeacher } from 'helpers/user';
import { getDocumentsByPlanId } from 'actions/documents';
import { getFileUrl } from 'actions/files';
import { fetch_preschoolgoals } from 'actions/preschoolform';
import Documentation from 'containers/Forms/Documentation';
import Modal from 'containers/Modals/Modal';
import LoadingCards from 'components/Cards/LoadingCard';
import Date from 'components/Presentation/Date/Date';
import SectionTitle from 'components/Presentation/SectionTitle';
import Block, { BlockWrapper } from 'UI/Elements/Block';
import { Button } from '@haldor/ui';
import FromNow from 'components/Presentation/Date/FromNow';

var PlanPosts = /*#__PURE__*/function (_Component) {
  _inherits(PlanPosts, _Component);

  var _super = _createSuper(PlanPosts);

  function PlanPosts(props) {
    var _this;

    _classCallCheck(this, PlanPosts);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var user = new User(_this.props.currentUser);
      var isPreschool = user.getActiveSchool().type == PRESCHOOL;

      _this.setState({
        loading: true
      });

      _this.props.getDocumentsByPlanId(_this.props.planId).then(function () {
        _this.setState({
          loading: false
        });
      });

      if (_this.props.preschoolGoals.length < 1 && isPreschool) {
        _this.props.fetch_preschoolgoals();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
      if (nextProps.planId != _this.props.planId) {
        _this.setState({
          loading: true
        });

        _this.props.getDocumentsByPlanId(nextProps.planId).then(function () {
          _this.setState({
            loading: false
          });
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDocumentModal", function () {
      _this.setState({
        documentModal: !_this.state.documentModal
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderCreateButton", function () {
      var isTeacher = isUserTeacher(_this.props.currentUser);

      if (isTeacher) {
        return /*#__PURE__*/React.createElement("div", {
          className: "create-container",
          style: {
            display: 'inline-block'
          }
        }, /*#__PURE__*/React.createElement(Button, {
          onClick: _this.toggleDocumentModal,
          type: "secondary"
        }, _this.props.translate('create-new')));
      } else {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "content", function (document) {
      var strippedDescription = '';

      if (document.description != null) {
        strippedDescription = document.description.replace(/(<([^>]+)>)/ig, '');

        if (strippedDescription.length > 99) {
          strippedDescription = strippedDescription.slice(0, 100) + '…';
        }
      }

      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
        style: {
          fontSize: '1.25em'
        }
      }, document.title), /*#__PURE__*/React.createElement("p", {
        style: {
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        },
        dangerouslySetInnerHTML: {
          __html: strippedDescription
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "headerContent", function (document) {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'left'
        }
      }, document.author != null ? typeof document.author == 'string' ? document.author : "".concat(document.author.firstName != null ? document.author.firstName : '', " ").concat(document.author.lastName != null ? document.author.lastName : '') : ' '), /*#__PURE__*/React.createElement("div", {
        style: {
          "float": 'right'
        }
      }, document.published != null ? Moment.utc(document.published).isAfter(Moment()) ? /*#__PURE__*/React.createElement(FromNow, null, Moment.utc(document.published).local().format()) : /*#__PURE__*/React.createElement(Date, null, Moment.utc(document.published).local()) : null), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "footerContent", function (document) {
      var preschoolGoals = _this.props.preschoolGoals;

      if (document.associatedGoals && document.associatedGoals.length > 0) {
        var groups = [];

        if (preschoolGoals && preschoolGoals.length > 0) {
          preschoolGoals.map(function (goal) {
            var inDocument = document.associatedGoals.find(function (goalOb) {
              return goalOb.goalId == goal.id;
            });

            if (typeof inDocument != 'undefined') {
              var inArray = groups.findIndex(function (i) {
                return i.name == goal.group;
              });

              if (inArray > -1) {
                return groups[inArray].count++;
              } else {
                var group = {
                  'name': goal.group,
                  'colorCode': goal.colorCode,
                  'count': 1
                };
                return groups.push(group);
              }
            }
          });
        }

        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, _this.props.translate('goals')), groups.length > 0 ? /*#__PURE__*/React.createElement("div", {
          className: "goal-preview-container"
        }, groups.map(function (group) {
          return /*#__PURE__*/React.createElement("div", {
            key: "goal-".concat(group.name),
            style: {
              backgroundColor: group.colorCode
            },
            className: "goal-preview"
          }, group.name, " (", group.count, ")");
        })) : null);
      } else {
        return null;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderDocument", function (document) {
      var link = '';
      var file = null;
      link = '/preschooldocument/' + document.id;

      if (document.associatedFiles != null && document.associatedFiles.length > 0) {
        file = document.associatedFiles.find(function (file) {
          return file.type.indexOf('image') > -1;
        });
      }

      return /*#__PURE__*/React.createElement(Block, {
        headerContent: _this.headerContent(document),
        image: file,
        content: _this.content(document),
        footerContent: _this.footerContent(document),
        link: link
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSectionContent", function () {
      var documents = _this.props.documents;

      if (documents.length > 0) {
        return /*#__PURE__*/React.createElement(BlockWrapper, {
          cols: 3
        }, documents ? documents.map(function (document, index) {
          return _this.renderDocument(document);
        }) : null);
      } else {
        return /*#__PURE__*/React.createElement("h4", {
          style: {
            textAlign: 'center'
          }
        }, _this.props.translate('no-items-found'));
      }
    });

    _this.state = {
      documentModal: false,
      loading: true
    };
    return _this;
  }

  _createClass(PlanPosts, [{
    key: "render",
    value: function render() {
      var loading = this.state.loading;
      var isTeacher = isUserTeacher(this.props.currentUser);
      var relations = {
        relationships: [{
          referenceType: 'SECTION',
          referenceId: this.props.sectionId
        }]
      };
      return /*#__PURE__*/React.createElement("div", {
        className: "single-section section preschooldocuments"
      }, isTeacher ? /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.documentModal,
        onClose: this.toggleDocumentModal,
        title: this.props.translate('create-new-documentation')
      }, /*#__PURE__*/React.createElement(Documentation, {
        planId: this.props.planId,
        values: relations,
        onModalClose: this.toggleDocumentModal,
        section: this.props.section
      })) : null, /*#__PURE__*/React.createElement(SectionTitle, null, this.props.translate('preschooldocument-posts'), this.renderCreateButton(), /*#__PURE__*/React.createElement(Link, {
        to: "/posts",
        className: "see-more"
      }, this.props.translate('show-all-posts'))), /*#__PURE__*/React.createElement("div", {
        className: "posts-section-container"
      }, /*#__PURE__*/React.createElement("div", null, loading ? /*#__PURE__*/React.createElement(LoadingCards, {
        count: 3
      }) : this.renderSectionContent()), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      })));
    }
  }]);

  return PlanPosts;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    documents: state.Documents.planDocuments,
    preschoolGoals: state.PreschoolGoals.preschoolGoals,
    groups: state.sections.educationGroups
  };
}

export default connect(mapStateToProps, {
  getDocumentsByPlanId: getDocumentsByPlanId,
  getFileUrl: getFileUrl,
  fetch_preschoolgoals: fetch_preschoolgoals
})(PlanPosts);